<template>
  <div>
    <template v-for="(value, index) in orders">
      <div class="page" style="position: relative; " :key="index">
        <v-flex xs12 md6 style="float:left; padding-top:100px; max-width:300px;">
          <v-flex style="font-size:16px; font-weight:bold">{{value.companyName}}</v-flex>
          <v-flex>{{value.billingAddress}}</v-flex>
          <v-flex>{{value.billingTown}} {{value.billingDistrict}}/{{value.billingCity}}</v-flex>
          <v-flex>Vergi No:{{value.taxNumber}}/ Vergi D:{{value.taxOffice}}</v-flex>
          <v-flex>TEL:{{value.phoneNumber}} TC:{{value.identityNo}}</v-flex>
        </v-flex>
        <v-flex xs12 md6 style="float:right ;margin:5px;padding-top:50px;">
          <span style="font-size:90px;" class="px-0">{{value.indicator}}</span>
          <v-flex style="font-weight:bold">{{value.items[0].orderNumber}}</v-flex>
          <v-flex>{{value.orderDate| formatDate}}</v-flex>
        </v-flex>
        <v-flex class="clear:both;"></v-flex>
        <table style="    width: 100%;padding-top:50px !important;">
          <tr>
            <th class="text-xs-left">Ürün</th>
            <th class="text-xs-left">Adet</th>
            <th class="text-xs-left">Birim Fiyat</th>
            <th class="text-xs-left">Tutar</th>
          </tr>
          <tr v-for="(item, itemIndex) in value.items" :key="itemIndex">
            <td>{{item.productName}}</td>
            <td>{{item.quantity}}</td>
            <td>{{item.price.amount| formatMoney}}</td>
            <td>{{item.totalPrice.amount | formatMoney}}</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td class="font-weight-bold">Toplam Tutar:</td>
            <td class="font-weight-bold">{{totalSum(value.items)| formatMoney}}</td>
          </tr>
        </table>

        <v-flex
          style="padding-top:144px; height:100px; bottom:0px; !important; font-weight:bold"
          class="subheading"
        >BİLGİLENDİRME AMAÇLIDIR, FATURA YERİNE GEÇMEZ. FATURANIZ E-FATURA OLARAK E-MAİL ADRESİNE GÖNDERİLECEKTİR.</v-flex>

        <!-- <div style="padding-bottom:439px;"></div> -->
      </div>
    </template>
  </div>
</template>
<style>
.application {
  background: #ffffff !important;
}
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background-color: #fafafa;
  font: 12pt "Tahoma";
}
* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}
.page {
  width: 210mm;
  min-height: 297mm;
  padding: 20mm;
  margin: 10mm auto;
  border: 1px #d3d3d3 solid;
  border-radius: 5px;
  background: white;
  position: relative;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}

@page {
  /* size: A4; */
  margin: 0;
}
@media print {

  html,
  body {
    width: 210mm;
    height: 297mm;
  }
  .page {
    margin: 0;
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }
}
</style>
<script>
import VueBarcode from "vue-barcode";

export default {
  data: () => ({
    orders: [],
    barcodeValue: "6219109850391"
  }),

  components: {
    // eslint-disable-next-line vue/no-unused-components
    barcode: VueBarcode
  },

  methods: {
    totalSum: function(x) {
      return this.format(
        x.reduce(function(total, item) {
          return total + item.totalPrice.amount;
        }, 0),
        2
      );
    },
    format(value, fixRound) {
      return Number(value.toFixed(fixRound));
    },
    injectInvoicePageStyle() {
      // @page scope edilemez; sertifikadaki "@page { size: 5in 3.5in }" (yatay) global sızıp faturayı
      // yatay bastırıyor. A4 dikey @page'i head'in en sonuna enjekte ederek ezeriz (sayfadan çıkınca kaldırılır).
      const id = "invoice-print-page-style";
      if (document.getElementById(id)) return;
      const style = document.createElement("style");
      style.id = id;
      style.textContent = "@page { size: A4 portrait; margin: 0; }";
      document.head.appendChild(style);
    }
  },
  mounted() {
    this.$store.commit("SET_LAYOUT", "empty-layout");
    this.injectInvoicePageStyle();
    // orders=this.$store.state.orders.selectedOrders;
    this.orders = JSON.parse(sessionStorage.getItem("invoiceprint")).sort(
      function(a, b) {
        return a.indicator > b.indicator ? 1 : -1;
      }
    );
    window.print();
  },
  beforeDestroy() {
    const el = document.getElementById("invoice-print-page-style");
    if (el) el.parentNode.removeChild(el);
  }
};
</script>
